import { z } from "zod";

export const name = z
  .string()
  .min(2, "Name must be at least 2 characters")
  .max(50, "Name must be at most 50 characters")
  .trim()
  .regex(
    /^[a-zA-Z\s-]+$/,
    "Name may only contain letters, spaces, and hyphens",
  );
